import { loadData } from "./dataLoader";

let origin;

loadData("saviors.json").then((data) => (origin = data));

const getSaviorById = (id) => origin.find((e) => e.id === id);
const getSaviorByName = (name) => origin.find((e) => e.name === name);

const getSaviorByNameTitle = (lang, string) => {
    const nameTitleRegex = new RegExp("(?<name>[a-zA-Z가-힣 ]+)\\((?<title>[a-zA-Z가-힣 ]+)\\)", "g");
    const result = nameTitleRegex.exec(string);

    if (result) {
        return origin.find((e) => e.name[lang] === result.groups?.name && e.title[lang] === result.groups?.title);
    } else {
        return result;
    }
};

export { getSaviorById, getSaviorByName, getSaviorByNameTitle };
